module.exports = __webpack_public_path__ + "static/logo-88a9c1579329c4eb67c28bbd22148c45.png";